module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"perPageItem":{"null":"Wszystkie"}}}')
  delete Component.options._Ctor
}
